import script from "./CardItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./CardItem.vue?vue&type=script&lang=ts&setup=true"

import "./CardItem.vue?vue&type=style&index=0&id=043a651e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-043a651e"]])

export default __exports__